import React from "react";
import { Counter } from "./fields";
import { money } from "@/lib/format";
import { useLang } from "@/i18n";
import { t } from "@/i18n";

function lineTotal(it) {
  const line = (it.qty || 0) * (it.rate || 0);
  const disc = (line * (it.discount || 0)) / 100;
  const taxable = line - disc;
  const gst = (taxable * (it.gst || 0)) / 100;
  return taxable + gst;
}

export function computeOrder(items) {
  let gross = 0, discount = 0, tax = 0, net = 0, totalQty = 0;
  items.forEach((it) => {
    const line = (it.qty || 0) * (it.rate || 0);
    const d = (line * (it.discount || 0)) / 100;
    const taxable = line - d;
    const g = (taxable * (it.gst || 0)) / 100;
    gross += line; discount += d; tax += g; net += taxable + g; totalQty += it.qty || 0;
  });
  return { gross, discount, tax, net, totalQty };
}

// items: [{product_id,name,pack_size,rate,gst,qty,discount}]
export function OrderEntry({ products, items, onChange, lang }) {
  const setItem = (pid, patch) => {
    const existing = items.find((i) => i.product_id === pid);
    let next;
    if (existing) {
      next = items.map((i) => (i.product_id === pid ? { ...i, ...patch } : i));
    } else {
      const p = products.find((x) => x.id === pid);
      next = [...items, { product_id: pid, name: p.name, pack_size: p.pack_size,
        rate: p.selling_price, gst: p.gst, discount: 0, qty: 0, ...patch }];
    }
    onChange(next.filter((i) => (i.qty || 0) > 0 || i.product_id === pid));
  };
  const totals = computeOrder(items);
  return (
    <div className="space-y-3" data-testid="order-entry">
      {products.map((p) => {
        const it = items.find((i) => i.product_id === p.id) || {};
        return (
          <div key={p.id} className="rounded-lg border border-slate-200 p-3 flex items-center gap-3">
            <div className="h-12 w-12 rounded-md bg-slate-100 overflow-hidden shrink-0">
              {p.image ? <img src={p.image} alt="" className="h-full w-full object-cover" /> : null}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-800 truncate">{p.name}</div>
              <div className="text-xs text-slate-500">{p.pack_size} · {money(p.selling_price)} · {p.gst}% GST</div>
              {it.qty > 0 && (
                <div className="text-xs font-semibold text-emerald-700 mt-0.5">
                  {t("qty", lang)} {it.qty} = {money(lineTotal(it))}
                </div>
              )}
            </div>
            <Counter value={it.qty || 0} onChange={(v) => setItem(p.id, { qty: v })} testid={`order-qty-${p.id}`} />
          </div>
        );
      })}
      <div className="rounded-lg bg-slate-800 text-white p-4 space-y-1 text-sm">
        <div className="flex justify-between"><span>{t("gross", lang)}</span><span>{money(totals.gross)}</span></div>
        <div className="flex justify-between text-slate-300"><span>{t("discount", lang)}</span><span>-{money(totals.discount)}</span></div>
        <div className="flex justify-between text-slate-300"><span>{t("tax", lang)}</span><span>+{money(totals.tax)}</span></div>
        <div className="flex justify-between text-lg font-bold border-t border-white/20 pt-2 mt-1">
          <span>{t("net_order", lang)}</span><span data-testid="order-net">{money(totals.net)}</span>
        </div>
      </div>
    </div>
  );
}
